import {env} from './env.ts';

export enum BuildEnvironment {
    DEV = 'dev',
    E2E = 'e2e',
    STAGING = 'staging',
    PROD = 'prod',
}

export function getBuildEnvironment(): BuildEnvironment {
    const currentEnvironment = env.buildEnvironment?.trim();

    if (currentEnvironment === BuildEnvironment.DEV) return BuildEnvironment.DEV;
    if (currentEnvironment === BuildEnvironment.E2E) return BuildEnvironment.E2E;
    if (currentEnvironment === BuildEnvironment.STAGING) return BuildEnvironment.STAGING;
    if (currentEnvironment === BuildEnvironment.PROD) return BuildEnvironment.PROD;

    return BuildEnvironment.DEV;
}
